import { c as _c } from "react/compiler-runtime";
import clsx from "classnames";
export interface TextProps {
  text: string;
  format?: Array<"italic" | "bold" | "strikethrough" | "underline">;
}
export const Text = t0 => {
  "use memo";

  const $ = _c(5);
  const {
    text,
    format
  } = t0;
  let t1;
  if ($[0] !== format) {
    t1 = clsx({
      "font-bold": format?.includes("bold"),
      italic: format?.includes("italic"),
      "line-through": format?.includes("strikethrough"),
      underline: format?.includes("underline")
    });
    $[0] = format;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const className = t1;
  let t2;
  if ($[2] !== className || $[3] !== text) {
    t2 = <span className={className}>{text}</span>;
    $[2] = className;
    $[3] = text;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};